import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-quill/dist/quill.snow.css'
import { Redirect } from 'react-router-dom';

import { getTokenInfo } from '../../UseToken';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import 'react-phone-number-input/style.css'
import Hosts, { companycode } from '../../Hosts';

import {

    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    set_language,
    content_language,
    translate,
    check_interface,

} from '../../Utils';

import Swal from 'sweetalert2'
import { language } from './Language';
import { color } from "../WEBContent/Color";
import { set } from 'core-js/core/dict';

export default function Regist(props) {
    const dados = useRef(null);
    const [, set_dados] = useState(null);
    const [isRedirect, setRedirect] = useState(false);
    const [isloading, setLoading] = useState(true);
    const [lang, set_lang] = useState('pt');

    const [is_edit, set_is_edit] = useState(false)
    const [, set_image_base64] = useState([])
    const [show_delete_button, set_show_delete_button] = useState(false)
    const [refresh, setRefresh] = useState(0);

    const event_type = useRef(null);
    const entidades = useRef(null);
    const departamentos = useRef(null);
    const grupos = useRef(null);

    const [departamentoGrupo, setDepartamentoGrupo] = useState("Departamento");

    const [selectedGrupo, setSelectedGrupo] = useState(null);
    const [selectedDepartamento, setSelectedDepartamento] = useState(null);
    const [selectedResponsaveis, setSelectedResponsaveis] = useState([]);

    const [files_image, set_files_image] = useState([])
    const [img_loader, set_img_loader] = useState([])

    const [name, setName] = useState(null)
    const [profile, setProfile] = useState(null)
    const [userID, setUserId] = useState(null)

    //Sondagens
    const [options, setOptions] = useState([]);
    const [newOption, setNewOption] = useState("");
    const [votes, setVotes] = useState({});

    console.log(dados, 'set_dados')

    const handle_add_option = () => {
        if (newOption.trim() === "") return;
        const id = Date.now().toString();
        const newOpt = { id, text: newOption };

        const updatedOptions = [...options, newOpt];
        setOptions(updatedOptions);
        setNewOption("");

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options: updatedOptions,
            votes: votes,
        };
        set_dados({});
    };

    const handle_remove_option = (id) => {
        const updatedOptions = options.filter((o) => o.id !== id);
        const updatedVotes = { ...votes };
        delete updatedVotes[id];

        setOptions(updatedOptions);
        setVotes(updatedVotes);

        dados.current.info.poll = {
            ...(dados.current.info.poll || {}),
            options: updatedOptions,
            votes: updatedVotes,
        };
        set_dados({});
    };

    const handle_toggle_vote = (id) => {
        setVotes((prev) => {
            const alreadyVoted = prev[id]?.some((u) => u.userID === userID);

            const updatedVotes = alreadyVoted
                ? { ...prev, [id]: prev[id].filter((u) => u.userID !== userID) }
                : { ...prev, [id]: [...(prev[id] || []), { userID, name, profile }] };

            dados.current.info.poll = {
                ...(dados.current.info.poll || {}),
                options: options,
                votes: updatedVotes,
            };
            set_dados({});
            return updatedVotes;
        });
    };

    const totalVotes = Object.values(votes).reduce(
        (acc, arr) => acc + arr.length,
        0
    );

    const handleSelect = (event) => {
        const value = event.target.value;
        setDepartamentoGrupo(value);
        console.log('departamentoGrupo', value);

        dados.current.info.departamentoGrupo = value;
        set_dados({ ...dados.current });
    };

    const fetch_id_info = async (id_serch) => {

        return await reqGET(`${api_crud_route}/${companycode}/${id_serch}`)
            .then(res => {

                set_dados(dados.current = res.data[0]);

            })
            .catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
    }

    const clean_data = () => {
        // DEEP COPY OF data_interface 
        set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
        set_dados(dados.current.info.companycode = getTokenInfo().companycode)
    }

    const uploadFilesImage = async (files, order, type, langid, lang) => {
        let aux = []
        return await files.forEach(async (element) => {
            if (element.type.includes('image/')) {
                aux.push(element)

                let y = img_loader
                y.push('img')
                set_img_loader(y)

                return await uploadFile(element, order, type, langid, lang)
                    .then(() => {
                        //console.log('success')
                    })
            }
            else {
                Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
            }
        })
    }

    const uploadFile = async (file, order, type, langid, lang) => {
        const formData = new FormData()
        formData.append('files', file)
        formData.append('id', dados.current.id)
        formData.append('file_name', file.name)
        formData.append('type', 'content')
        formData.append('companycode', getTokenInfo().companycode)
        formData.append('uniqid', '')
        formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

        return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
            .then(async (res) => {
                var today_file = new Date()

                let i = Date.now()

                let x = {
                    id: i,
                    info: {
                        companycode: getTokenInfo().companycode,
                        type: res.data.mimetype,
                        link: res.data.path + '/' + res.data.name,
                        size: res.data.size,
                        date: today_file
                    },
                    content: {
                        name: file.name,
                        description: '',
                        lang: []
                    }
                }

                dados.current.info.image = {
                    id: i,
                    url: res.data.path + '/' + res.data.name,
                    link: res.data.path + '/' + res.data.name,
                    type: res.data.mimetype,
                    size: res.data.size,
                    date: today_file
                }

                await reqPUT(api_crud_route, dados.current)
                    .then(() => {
                        //props.history.push(endpoints.list) 

                        reqPOST(`${api_crud_base}/multimedia`, x)
                            .then(() => {

                                let y2 = img_loader
                                y2.pop()
                                set_img_loader(y2)
                                setRefresh(i)

                            })
                            .catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

                    })
                    .catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

            })
            .catch(erro => console.log('Erro POST File: ' + erro))
    }

    useEffect(() => {

        clean_data();

        get_type_event()
        fetch_entidades()
        fetch_departamentos()
        fetch_grupos()

        set_lang(localStorage.getItem('lang'))

        const storedData = localStorage.getItem('token');
        const data = JSON.parse(storedData);

        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info) {
                if (data.user_info.user_info) {

                } else {

                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);
                    setUserId(data.user_info.id);

                }

            } else {
                console.log('User info não encontrado no localStorage');
            }

        } else {
            console.log('Dados não encontrados no localStorage');
        }

        try {
            let test = props.location.state.operation;

            if (test === 'edit') {
                //set_disabled(true)

                set_is_edit(true)
                set_show_delete_button(true)

                set_image_base64([])

                fetch_id_info(props.location.state.item.id).then(() => {
                    setLoading(false)
                    //setRefresh(refresh + 1)
                })
                return
            }
            else {
                set_dados(dados.current.info.order = parseInt(props.location.state.item['order']) + 1)
                setLoading(false)
            }

        } catch {
            clean_data()

            setLoading(false);

            setRedirect(false);
            return
        }

        return () => {
            clean_data()

        }

    }, [props])

    const get_type_event = async () => {
        let res_event = await reqGET(`${api_crud_base}/evento/type/${getTokenInfo().companycode}/event_type`);
        let result = [];

        if (res_event.data !== undefined) {
            result = res_event.data.filter(el => el.info.avaiable === true);
        }

        set_dados(event_type.current = result);
        //console.log('Event Type', event_type.current)
    };

    const fetch_entidades = async () => {
        try {
            let res_entidade = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`);
            let result = [];

            if (res_entidade.data !== undefined) {
                result = res_entidade.data.filter(el => el.entity_type === "1");
            }

            set_dados(entidades.current = result);
            console.log('Entidades', entidades.current)

        } catch (error) {
            console.error("Erro ao buscar as Entidades:", error);
            return [];
        }

    };

    const fetch_departamentos = async () => {
        try {
            let res_departamento = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
            set_dados(departamentos.current = res_departamento.data);
            console.log('Departamentos', departamentos.current)

        } catch (error) {
            console.error("Erro ao buscar os departamentos:", error);
            return [];
        }
    };

    const fetch_grupos = async () => {
        try {
            let res_grous = await reqGET(`${Hosts.SIMCore_API}/intranet/groups/${getTokenInfo().companycode}`);
            set_dados(grupos.current = res_grous.data);
            console.log('Grupos', grupos.current)

        } catch (error) {
            console.error("Erro ao buscar os grupos:", error);
            return [];
        }
    };

    useEffect(() => {
        if (dados.current?.info?.poll) {
            const { options: savedOptions = [], votes: savedVotes = {} } =
                dados.current.info.poll;

            setOptions(savedOptions);
            setVotes(savedVotes);
        }

        if (departamentoGrupo && dados.current) {
            if (dados.current.info?.departamentoGrupo) {
                setDepartamentoGrupo(dados.current.info.departamentoGrupo);
            } else {
                dados.current.info.departamentoGrupo = departamentoGrupo;
            }
        }

        if (dados.current?.info?.departamento && !selectedDepartamento) {
            setSelectedDepartamento(dados.current.info.departamento);
        }

        if (dados.current?.info?.grupo && !selectedGrupo) {
            setSelectedGrupo(dados.current.info.grupo);
        }

        if (
            dados.current?.info?.responsaveis &&
            selectedResponsaveis.length === 0
        ) {
            setSelectedResponsaveis(dados.current.info.responsaveis);
        }

    }, [dados.current]);

    const change_grupo = (event) => {
        const grupoId = event.target.value;
        setSelectedGrupo(grupoId);
        setSelectedDepartamento([]);

        const grupoSelecionado = (grupos.current || []).find(
            (g) => String(g.id) === String(grupoId)
        );

        const responsaveisGrupo = grupoSelecionado?.info.responsaveis || [];
        setSelectedResponsaveis(responsaveisGrupo);

        set_dados((prev) => ({
            ...prev,
            current: {
                ...(prev?.current || {}),
                info: {
                    ...(prev?.current?.info || {}),
                    grupo: grupoId,
                    responsaveis: responsaveisGrupo,
                },
            },
        }));
    };

    const change_departamento = (event) => {
        const departamento = event.target.value;

        setSelectedDepartamento(departamento);
        setSelectedGrupo([])
        setSelectedResponsaveis([]);

        set_dados((prev) => ({
            ...prev,
            current: {
                ...(prev?.current || {}),
                info: {
                    ...(prev?.current?.info || {}),
                    departamento: departamento,
                },
            },
        }));
    };

    const responsaveisFiltrados = (entidades.current || []).filter((entidade) =>
        entidade?.departamento?.some(
            (dep) => String(dep.id) === String(selectedDepartamento)
        )
    );

    const change_responsaveis = (responsavel) => {
        setSelectedResponsaveis((prev) => {
            let updated;
            if (prev.some((item) => item.id === responsavel.id)) {
                updated = prev.filter((item) => item.id !== responsavel.id);
            } else {
                updated = [...prev, responsavel];
            }

            set_dados((prev) => ({
                ...prev,
                current: {
                    ...(prev?.current || {}),
                    info: {
                        ...(prev?.current?.info || {}),
                        responsaveis: updated,
                    },
                },
            }));

            return updated;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const unique_code = new Date().valueOf();
        dados.current.info.unique_code = '' + unique_code + '';

        dados.current.info.departamento = selectedDepartamento;
        dados.current.info.grupo = selectedGrupo;
        dados.current.info.responsaveis = selectedResponsaveis;

        if (is_edit === true) {
            Swal.fire({
                title: language[lang].edit_title,
                text: language[lang].edit_text,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#0095e8",
                cancelButtonColor: "#d9214e",
                confirmButtonText: language[lang].edit_confirm,
                cancelButtonText: language[lang].edit_cancel,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    for (const el_image of files_image) {
                        if (el_image?.files?.length > 0) {
                            await uploadFilesImage(
                                el_image.files,
                                el_image.order,
                                "image",
                                el_image.langid,
                                el_image.lang
                            );
                        }
                    }

                    let aux = {
                        id: dados.current.id,
                        unique_code: dados.current.info.unique_code,
                        companycode: dados.current.info.companycode,

                        type: 'evento',
                        title: dados.current.info.title,
                        description: dados.current.info.description,

                        date: dados.current.info.date,
                        time: dados.current.info.time,
                        location: dados.current.info.location,

                        departamentoGrupo: dados.current.info.departamentoGrupo,
                        grupo: dados.current.info.grupo,
                        departamento: dados.current.info.departamento,
                        responsaveis: dados.current.info.responsaveis
                    };

                    reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

                    window.location.reload();

                    set_files_image([]);
                    set_image_base64([]);

                    reqPUT(api_crud_route, dados.current)
                        .then(() => {
                            //props.history.push(endpoints.list)
                        })
                        .catch(() => Swal.fire(language[lang].edit_error, "", "info"));
                }
            });
        } else {
            Swal.fire({
                title: language[lang].insert_title,
                text: language[lang].insert_text,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#0095e8",
                cancelButtonColor: "#d9214e",
                confirmButtonText: language[lang].insert_confirm,
                cancelButtonText: language[lang].insert_cancel,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    for (const el_image of files_image) {
                        if (el_image?.files?.length > 0) {
                            await uploadFilesImage(
                                el_image.files,
                                el_image.order,
                                "image",
                                el_image.langid,
                                el_image.lang
                            );
                        }
                    }

                    let aux = {
                        id: dados.current.id,
                        unique_code: dados.current.info.unique_code,
                        companycode: dados.current.info.companycode,

                        type: 'evento',
                        title: dados.current.info.title,
                        description: dados.current.info.description,

                        date: dados.current.info.date,
                        time: dados.current.info.time,
                        location: dados.current.info.location,

                        departamentoGrupo: dados.current.info.departamentoGrupo,
                        grupo: dados.current.info.grupo,
                        departamento: dados.current.info.departamento,
                        responsaveis: dados.current.info.responsaveis
                    };

                    reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

                    const currentDateTime = new Date().toISOString();

                    if (!dados.current.info.createadBy) {
                        dados.current.info.createadBy = [];
                    }

                    if (dados.current.info.createadBy.length === 0) {
                        dados.current.info.createadBy.push({
                            userId: userID,
                            timestamp: currentDateTime
                        });
                    }

                    set_files_image([]);
                    set_image_base64([]);

                    reqPOST(api_crud_route, dados.current)
                        .then(() => {
                            props.history.push(endpoints.list);
                        })
                        .catch(() =>
                            Swal.fire(language[lang].insert_error, "", "info")
                        );

                }
            });
        }
        set_dados(dados.current);
    };

    function apagar() {
        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: dados.current.id })
                        .then(() => {
                            props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
            .catch((erro) => {
                console.log(erro)
            })

    };

    const handle_change_info = (e) => {
        const { name, value } = e.target;
        dados.current.info[name] = value;
        set_dados({});
    };

    const handle_change_event_type = (e) => {
        const selectedId = e.target.value;
        const selectedLabel = e.target.options[e.target.selectedIndex].text;
        const selectedPollActive = event_type.current.find(el => el.id === selectedId)?.info.poll_active || false;
        const selectedSelectColab = event_type.current.find(el => el.id === selectedId)?.info.select_colab || false;

        dados.current.info.event_type = {
            id: selectedId,
            name: selectedLabel,
            poll_active: selectedPollActive,
            select_colab: selectedSelectColab,
        };

        set_dados({});
    };

    const handle_change_deadline = (e) => {
        const { name, value } = e.target;
        dados.current.info.poll[name] = value;
        set_dados({});
    };

    /*
    const handle_change_info = (e) => {
        const { name, value, dataset } = e.target;
        const { lang } = dataset
 
        if (name === 'name' && 0) {
            let value_aux = {}
            let aux = dados.current.info.name.filter(e => e[lang])
            if (aux !== undefined && aux.length === 0) {
                value_aux[lang] = value
                dados.current.info.name.push(value_aux)
            }
            else {
                dados.current.info.name.forEach(el => {
                    if (el[lang] !== undefined) {
                        el[lang] = value
                    }
                })
            }
        }
 
        dados.current.info[name] = value
    }
    */

    const handle_change_info_translate = (e) => {
        const { name, value, dataset } = e.target;
        const { lang, langid } = dataset

        if (dados.current.info[name] === undefined) {
            dados.current.info[name] = []
        }

        let value_aux = {}
        let aux = dados.current.info[name].filter(e => e[lang])
        if (aux !== undefined && aux.length === 0) {
            value_aux[lang] = value
            dados.current.info[name].push(value_aux)
        }
        else {
            dados.current.info[name].forEach(el => {
                if (el[lang] !== undefined) {
                    el[lang] = value
                }
            })
        }

        if (name === 'title' && parseInt(langid) === 1) {
            dados.current.info.name = value
        }

    }

    const handle_change_info_color = (e) => {
        const { name, value } = e.target;

        if (dados.current.info.color === undefined) {
            dados.current.info.color = { primary: '', primary_rgb: '', secondary: '' }
        }

        let color_rgb = hex2rgb(value)

        if (name === 'primary') {
            dados.current.info.color['primary_rgb'] = color_rgb
        }

        dados.current.info.color[name] = value

        set_dados(dados.current.info)
        setRefresh(refresh + 1)
    }

    function hex2rgb(value) {
        var hex_color = value
        var pattern_color = "^#([A-Fa-f0-9]{6})$";
        if (hex_color.match(pattern_color)) {
            var hex_color_aux = hex_color.replace("#", "")
                , r = parseInt(hex_color_aux.substring(0, 2), 16)
                , g = parseInt(hex_color_aux.substring(2, 4), 16)
                , b = parseInt(hex_color_aux.substring(4, 6), 16);
            return '' + r + ',' + g + ',' + b + '';
        }
        else {
            alert('Error Color Format');
        }
    }

    const handleSingleCheckActive = () => {
        set_dados(dados.current.info.active = !dados.current.info.active)
    }

    return isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{language[lang].loading}</h2>
                <p>{language[lang].loading}</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>
            </div>
        </main>
        :
        isRedirect
            ?
            <Redirect to={endpoints.list} replace />
            :
            <main>
                <div className={`dash-cards header`}>
                    <div className="container">
                        <h2 className="dash-title">{language[lang].component}</h2>
                        <p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
                    </div>
                </div>

                <div className={`dash-cards body`}>
                    <div className="container">
                        <div className="row">
                            <div className="mb-5 mb-xl-10">
                                <div className='card'>
                                    <div className="card-header border-0 d-flex justify-content-between align-items-center p-4">
                                        <div className="card-title m-0">
                                            <h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
                                        </div>
                                        <div className="card-toolbar">
                                            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                                                {
                                                    content_language.length > 1 ?
                                                        content_language.map((el_lang, k_lang) => {
                                                            return (
                                                                <li key={k_lang} className="nav-item d-none">
                                                                    <a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
                                                                </li>
                                                            )
                                                        })
                                                        :
                                                        null
                                                }
                                            </ul>
                                        </div>
                                    </div>

                                    <div id="div-content">
                                        <form id="form" onSubmit={handleSubmit}>
                                            <div className="card-body border-top p-4">
                                                <div className='tab-content'>                                                    {
                                                    content_language.length > 0 ?
                                                        content_language.map((el_lang, k_lang) => {
                                                            return (
                                                                <div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
                                                                    <div className="row mb-3">
                                                                        <div className="col-6">
                                                                            <label
                                                                                className={"fs-6 fw-bold mb-2" + (el_lang.id === '1' ? ' required' : '')}>
                                                                                {language[lang].field_name}
                                                                                {k_lang > 0 ? '(' + el_lang.code + ')' : ''}
                                                                            </label>
                                                                            <input type="text" name="title" data-langid={el_lang.id} data-lang={el_lang.code} defaultValue={translate(dados.current.info.title, el_lang.code)} onChange={(e) => handle_change_info_translate(e)} className="form-control rounded-0" required={el_lang.id === '1' ? 'required' : ''} />
                                                                        </div>

                                                                        {
                                                                            el_lang.id === '1' || true ?
                                                                                <div className="col-2">
                                                                                    <div className="d-flex">
                                                                                        <div className="ms-3 mb-3">
                                                                                            <label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
                                                                                            <div className="input-group">
                                                                                                <label className="switch">
                                                                                                    <input
                                                                                                        id={'item-switch-active'}
                                                                                                        name={"active"}
                                                                                                        className=""
                                                                                                        type="checkbox"
                                                                                                        value={dados.current.info?.active}
                                                                                                        onChange={handleSingleCheckActive}
                                                                                                        defaultChecked={dados.current.info.active}
                                                                                                    />
                                                                                                    <span className="slider" htmlFor={'item-switch-active'}></span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                                :
                                                                                null
                                                                        }
                                                                    </div>

                                                                    <div className="row mb-4">
                                                                        <div className="col-6">
                                                                            <label className={"fs-6 fw-bold mb-2"}>{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
                                                                            <textarea
                                                                                type="text"
                                                                                rows="4"
                                                                                name="description"
                                                                                data-langid={el_lang.id}
                                                                                data-lang={el_lang.code}
                                                                                defaultValue={translate(dados.current.info.description, el_lang.code)}
                                                                                onChange={(e) => handle_change_info_translate(e)}
                                                                                className="form-control rounded-0"
                                                                            />
                                                                        </div>

                                                                        <div className="col-md-2 ms-3 mb-3 d-none">
                                                                            <label className="fs-6 fw-bold mb-2">{language[lang].color_primary}</label>
                                                                            <input
                                                                                type="color"
                                                                                name="primary"
                                                                                className="form-control form-control-color rounded-0"
                                                                                value={dados.current.info?.color?.primary || "#000000"}
                                                                                onChange={handle_change_info_color}
                                                                            />
                                                                        </div>

                                                                        <div className="col-md-2 mb-3 d-none">
                                                                            <label className="fs-6 fw-bold mb-2">{language[lang].color_secondary}</label>
                                                                            <input
                                                                                type="color"
                                                                                name="secondary"
                                                                                className="form-control form-control-color rounded-0"
                                                                                value={dados.current.info?.color?.secondary || "#FFFFFF"}
                                                                                onChange={handle_change_info_color}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="row mb-3">
                                                                        {/* Event Type */}
                                                                        <div className="col-4 col-md-4">
                                                                            <label className="fs-6 fw-bold mb-2">
                                                                                {language[lang].event_type}
                                                                            </label>
                                                                            <select
                                                                                name="event_type"
                                                                                className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                onChange={handle_change_event_type}
                                                                                value={dados?.current?.info?.event_type?.id || ''}
                                                                                required
                                                                            >
                                                                                <option value="">{language[lang].select}</option>
                                                                                {event_type.current?.filter(el => el.info.avaiable)
                                                                                    .map((el, k) => (
                                                                                        <option key={k} value={el.id}>
                                                                                            {el.info.name}
                                                                                        </option>
                                                                                    ))}
                                                                            </select>
                                                                        </div>

                                                                        {/* Prioridade */}
                                                                        <div className="col-md-4">
                                                                            <label className="fs-6 fw-bold mb-2">{language[lang].field_prioridade}</label>
                                                                            <select
                                                                                name="prioridade"
                                                                                className="form-select form-control rounded-0"
                                                                                value={dados.current.info?.prioridade || ""}
                                                                                onChange={handle_change_info}
                                                                            >
                                                                                <option value="">{language[lang].select}</option>
                                                                                <option value="Critica">{language[lang].critica}</option>
                                                                                <option value="Urgente">{language[lang].urgente}</option>
                                                                                <option value="Normal">{language[lang].normal}</option>
                                                                                <option value="Pouco Urgente">{language[lang].pouco_urgente}</option>
                                                                                <option value="Nao Urgente">{language[lang].nao_urgente}</option>
                                                                            </select>
                                                                        </div>

                                                                        {/* Localização */}
                                                                        <div className="col-md-4">
                                                                            <label className="fs-6 fw-bold mb-2">{language[lang].field_location}</label>
                                                                            <input
                                                                                type="text"
                                                                                name="location"
                                                                                className="form-control rounded-0"
                                                                                value={dados.current.info?.location || ""}
                                                                                onChange={handle_change_info}
                                                                                placeholder={language[lang].field_location_placeholder}
                                                                            />
                                                                        </div>

                                                                    </div>

                                                                    <div className="row mb-3">
                                                                        {/* Data */}
                                                                        <div className="col-md-4">
                                                                            <label className="fs-6 fw-bold mb-2">{language[lang].field_date}</label>
                                                                            <input
                                                                                type="date"
                                                                                name="date"
                                                                                className="form-control rounded-0"
                                                                                value={dados.current.info?.date || ""}
                                                                                onChange={handle_change_info}
                                                                            />
                                                                        </div>

                                                                        {/* Hora */}
                                                                        <div className="col-md-4">
                                                                            <label className="fs-6 fw-bold mb-2">{language[lang].field_time}</label>
                                                                            <input
                                                                                type="time"
                                                                                name="time"
                                                                                className="form-control rounded-0"
                                                                                value={dados.current.info?.time || ""}
                                                                                onChange={handle_change_info}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Votação */}
                                                                    {dados.current.info?.event_type?.poll_active === true && (
                                                                        <div className="row mb-3">
                                                                            <div className="col-md-4">
                                                                                <label className="fs-6 fw-bold mb-2">
                                                                                    {language[lang].votacao_oculta}
                                                                                </label>
                                                                                <select
                                                                                    name="votacao_oculta"
                                                                                    className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                    onChange={(e) => {
                                                                                        dados.current.info.votacao_oculta = e.target.value;

                                                                                        if (e.target.value === "2") {
                                                                                            dados.current.info.votacao = "1";
                                                                                        }

                                                                                        handle_change_info(e);
                                                                                    }}
                                                                                    required={dados.current.info?.event_type?.poll_active === true ? 'required' : ''}
                                                                                    value={
                                                                                        dados?.current?.info?.votacao_oculta !== undefined &&
                                                                                            dados?.current?.info?.votacao_oculta !== null
                                                                                            ? dados.current.info.votacao_oculta
                                                                                            : ''
                                                                                    }
                                                                                >
                                                                                    <option value="">{language[lang].select}</option>
                                                                                    <option value="1">{language[lang].livre}</option>
                                                                                    <option value="2">{language[lang].oculta}</option>
                                                                                </select>
                                                                            </div>

                                                                            <div className="col-md-4">
                                                                                <label className="fs-6 fw-bold mb-2">
                                                                                    {language[lang].votacao}
                                                                                </label>
                                                                                <select
                                                                                    name="votacao"
                                                                                    className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                    onChange={(e) => {
                                                                                        dados.current.info.votacao = e.target.value;
                                                                                        handle_change_info(e);
                                                                                    }}
                                                                                    required={dados.current.info?.event_type?.poll_active === true ? 'required' : ''}
                                                                                    disabled={dados.current.info?.votacao_oculta === "2"}
                                                                                    value={
                                                                                        dados?.current?.info?.votacao !== undefined &&
                                                                                            dados?.current?.info?.votacao !== null
                                                                                            ? dados.current.info.votacao
                                                                                            : ''
                                                                                    }
                                                                                >
                                                                                    <option value="">{language[lang].select}</option>
                                                                                    <option value="1">{language[lang].singular}</option>
                                                                                    <option value="2">{language[lang].multipla}</option>
                                                                                </select>
                                                                            </div>

                                                                            <div className="col-md-4">
                                                                                <label className="fs-6 fw-bold mb-2">
                                                                                    {language[lang].event_poll_bloquear}
                                                                                </label>
                                                                                <input
                                                                                    type="date"
                                                                                    name="poll_deadline_date"
                                                                                    className="form-control rounded-0 mb-2"
                                                                                    value={dados.current.info?.poll?.poll_deadline_date || ""}
                                                                                    onChange={handle_change_deadline}
                                                                                />
                                                                                <input
                                                                                    type="time"
                                                                                    name="poll_deadline_time"
                                                                                    className="form-control rounded-0"
                                                                                    value={dados.current.info?.poll?.poll_deadline_time || ""}
                                                                                    onChange={handle_change_deadline}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {dados.current.info?.event_type?.select_colab === true && (
                                                                        <div>
                                                                            <div className="row mb-3">
                                                                                <div className="col-md-6">
                                                                                    <label className="fs-6 fw-bold mb-2">
                                                                                        {language[lang].departamento} {language[lang].or} {language[lang].grupo}
                                                                                    </label>
                                                                                    <select
                                                                                        id="selectTipo"
                                                                                        value={dados.current.info?.departamentoGrupo || departamentoGrupo}
                                                                                        onChange={handleSelect}
                                                                                        disabled={profile === "Colaborador"}
                                                                                        className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                    >
                                                                                        <option value="1">{language[lang].departamento}</option>
                                                                                        <option value="2">{language[lang].grupo}</option>
                                                                                    </select>
                                                                                </div>

                                                                                <div className="col-md-6">
                                                                                    {departamentoGrupo === "2" && (
                                                                                        <div>
                                                                                            <label className="fs-6 fw-bold mb-2">
                                                                                                {language[lang].grupo}
                                                                                            </label>
                                                                                            <select
                                                                                                id="selectGrupo"
                                                                                                value={
                                                                                                    selectedGrupo ||
                                                                                                    dados.current?.info?.grupo ||
                                                                                                    ""
                                                                                                }
                                                                                                onChange={change_grupo}
                                                                                                className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                                required
                                                                                            >
                                                                                                <option value="">
                                                                                                    {language[lang].grupo_placeholder}
                                                                                                </option>
                                                                                                {(grupos.current || []).map((g) => (
                                                                                                    <option key={g.id} value={g.id}>
                                                                                                        {g.info?.name || g.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                                {console.log('grupos.current', grupos.current)}
                                                                                            </select>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            <div className="row mb-3">
                                                                                <div className="col-md-6">
                                                                                    {departamentoGrupo === "1" && (
                                                                                        <div>
                                                                                            <label className="fs-6 fw-bold mb-2">
                                                                                                {language[lang].departamento}
                                                                                            </label>
                                                                                            <select
                                                                                                id="selectDepartamento"
                                                                                                value={
                                                                                                    selectedDepartamento ||
                                                                                                    dados.current?.info?.departamento ||
                                                                                                    ""
                                                                                                }
                                                                                                onChange={change_departamento}
                                                                                                className="form-select form-control mb-4 mb-lg-0 rounded-0"
                                                                                                required
                                                                                            >
                                                                                                <option value="">
                                                                                                    {language[lang].departamento_placeholder}
                                                                                                </option>
                                                                                                {(departamentos.current || []).map((dep) => (
                                                                                                    <option key={dep.id} value={dep.id}>
                                                                                                        {dep.info?.name || dep.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                                <div className="col-md-4 mb-4">
                                                                                    {departamentoGrupo === "1" && selectedDepartamento && (
                                                                                        <div>
                                                                                            <label className="fs-6 fw-bold mb-2">
                                                                                                {language[lang].responsaveis}
                                                                                            </label>

                                                                                            <ul className="list-unstyled">
                                                                                                {(responsaveisFiltrados || []).map((responsavel) => (
                                                                                                    <li key={responsavel.id} className="mb-2">
                                                                                                        <div className="form-check">
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                checked={selectedResponsaveis.some(
                                                                                                                    (item) => item.id === responsavel.id
                                                                                                                )}
                                                                                                                onChange={() => change_responsaveis(responsavel)}
                                                                                                                className="form-check-input"
                                                                                                                id={`responsavel-${responsavel.id}`}
                                                                                                                value={responsavel.id}
                                                                                                            />
                                                                                                            <label
                                                                                                                className="form-check-label"
                                                                                                                htmlFor={`responsavel-${responsavel.id}`}
                                                                                                            >
                                                                                                                {responsavel.name}
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    </li>
                                                                                                ))}
                                                                                            </ul>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        })
                                                        :
                                                        null
                                                }
                                                </div>
                                            </div>

                                            {/*
                                                <div className='card-body border-top p-4'>
                                                    <div className="row mt-4 mb-3">
                                                        <div className="container mt-4">

                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <h5 className="mb-4">
                                                                    {language[lang].event_poll} - {
                                                                        lang === 'en'
                                                                            ? dados.current.info?.title?.[0]?.en || ''
                                                                            : dados.current.info?.title?.[0]?.pt || ''
                                                                    }
                                                                </h5>
                                                            </div>
                                                           
                                                            <div className="list-group">
                                                                {options.map((o) => {
                                                                    const userVoted = votes[o.id]?.some((u) => u.userID === userID);
                                                                    const optionVotes = votes[o.id]?.length || 0;
                                                                    const percent =
                                                                        totalVotes > 0 ? Math.round((optionVotes / totalVotes) * 100) : 0;

                                                                    return (
                                                                        <div
                                                                            key={o.id}
                                                                            className="list-group-item d-flex flex-column mb-3 shadow-sm rounded"
                                                                        >
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <div>
                                                                                    <strong>{o.text}</strong>
                                                                                    <div className="d-flex mt-1">
                                                                                        {(votes[o.id] || []).map((u) => {
                                                                                            const entidade = entidades.current?.find(
                                                                                                (e) => e.id === u.userID
                                                                                            );

                                                                                            let fotoUrl = "/default-avatar.png";
                                                                                            if (entidade?.foto) {
                                                                                                try {
                                                                                                    const fotos = JSON.parse(entidade.foto);
                                                                                                    if (Array.isArray(fotos) && fotos.length > 0) {
                                                                                                        fotoUrl = fotos[0].link;
                                                                                                    }
                                                                                                } catch (err) {
                                                                                                    console.warn("Foto JSON inválido:", entidade.foto);
                                                                                                }
                                                                                            }

                                                                                            return (
                                                                                                <img
                                                                                                    key={u.userID}
                                                                                                    src={fotoUrl}
                                                                                                    alt={entidade?.name || "user"}
                                                                                                    title={entidade?.name || "Sem nome"}
                                                                                                    className="rounded-circle me-1 border"
                                                                                                    style={{ width: "28px", height: "28px" }}
                                                                                                />
                                                                                            );
                                                                                        })}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="btn-group">
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => handle_toggle_vote(o.id)}
                                                                                        className="btn btn-sm text-white"
                                                                                        style={{
                                                                                            backgroundColor: userVoted
                                                                                                ? color.corNormal.rgb
                                                                                                : color.corNaoUrgente.rgb,
                                                                                            minWidth: "120px",
                                                                                        }}
                                                                                    >
                                                                                        {userVoted ? "Remover voto" : "Votar"}
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => handle_remove_option(o.id)}
                                                                                        className="btn btn-sm text-white"
                                                                                        style={{
                                                                                            backgroundColor: color.corCritica.rgb,
                                                                                            minWidth: "120px",
                                                                                        }}
                                                                                    >
                                                                                        {language[lang].remove}
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            <div className="progress" style={{ height: "10px" }}>
                                                                                <div
                                                                                    className="progress-bar"
                                                                                    role="progressbar"
                                                                                    style={{
                                                                                        width: `${percent}%`,
                                                                                        backgroundColor: color.corUrgente.hexa,
                                                                                    }}
                                                                                    aria-valuenow={percent}
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100"
                                                                                />
                                                                            </div>
                                                                            <small className="text-muted mt-1">
                                                                                {optionVotes} {language[lang].votes} ({percent}%)
                                                                            </small>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>

                                                            <div className="input-group mt-4 mb-4">
                                                                <input
                                                                    type="text"
                                                                    value={newOption}
                                                                    onChange={(e) => setNewOption(e.target.value)}
                                                                    placeholder="Escreve uma nova opção..."
                                                                    className="form-control"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={handle_add_option}
                                                                    className="btn"
                                                                    style={{
                                                                        backgroundColor: color.corNaoUrgente.rgb,
                                                                        color: "#fff",
                                                                        minWidth: "100px",
                                                                    }}
                                                                >
                                                                    {language[lang].add}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            */}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >

                <div className={'dash-cards footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
                                    </Link>
                                </li>
                                
                                {(dados.current?.info?.createdBy?.userId === userID || profile === "Administrador") &&
                                    < li className={"nav-item " + show_delete_button}>
                                        <button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
                                            <i className="bi bi-trash3 me-2"></i>
                                            <span>{language[lang].delete}</span>
                                        </button>
                                    </li>
                                }

                                <li className="nav-item">
                                    <button type="submit" form="form" className="nav-link">
                                        <i className="bi bi-floppy me-2"></i>
                                        <span>{language[lang].save}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div >
            </main >
}